import React, { useEffect } from 'react'
import LoginFrame from '../shared/LoginFrame'
import AuthCollage from '../icons/AuthCollageIcon'
import { eventHandler } from '../../types.d'
import { useAppSelector, useAppDispatch } from '../../store/store'
import { enrollPasskey, suggestPasskey } from '../../store'
import {
  InjectedFrameProps,
  withFrameProps,
} from '../../context/withFrameProps'
import { preventDefault } from '../../helpers'
import PasskeyProgressIcon from '../icons/PasskeyProgressIcon'
import { WebAuthnAbortService } from '@simplewebauthn/browser'

type PureCreatePasskeyLoadingProps = {
  onCancel: eventHandler
  email?: string
} & Exclude<InjectedFrameProps, 'hasPreviousStep'>

export const PureCreatePasskeyLoading = ({
  onCancel,
  loading,
  email,
  logoUrl = null,
}: PureCreatePasskeyLoadingProps) => (
  <LoginFrame
    title={null}
    disableError={true}
    recaptchaSiteKey={null}
    {...{ loading, logoUrl }}
  >
    {email && (
      <input
        type="text"
        name="email"
        value={email}
        autoComplete="username"
        readOnly
        hidden
      />
    )}
    <div className="space-y-4">
      <div className="flex items-center justify-center">
        <PasskeyProgressIcon />
      </div>
      <p className="text-center mt-3">
        Continue with your browser to create your passkey
      </p>
    </div>
    <button
      onClick={preventDefault(onCancel)}
      type="submit"
      tabIndex={1}
      className="w-full text-white bg-slate-600 hover:bg-slate-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
    >
      Cancel
    </button>
  </LoginFrame>
)

const BoundCreatePasskeyLoading = withFrameProps(PureCreatePasskeyLoading, {})

export const CreatePasskeyLoading = () => {
  const dispatch = useAppDispatch()
  const state = useAppSelector((state) => state.auth)
  const email = state.signin?.userInfo?.email || state.signup?.email

  useEffect(() => {
    const timeoutId = setTimeout(() => dispatch(enrollPasskey()), 200)
    return () => {
      clearTimeout(timeoutId)
      WebAuthnAbortService.cancelCeremony()
    }
  }, [])

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    dispatch(suggestPasskey())
  }

  return <BoundCreatePasskeyLoading onCancel={handleCancel} email={email} />
}

export default CreatePasskeyLoading
